import { render } from "./DonatedProduct.vue?vue&type=template&id=65fce26f&scoped=true&lang=html"
import script from "./DonatedProduct.vue?vue&type=script&lang=js"
export * from "./DonatedProduct.vue?vue&type=script&lang=js"

import "./DonatedProduct.vue?vue&type=style&index=0&id=65fce26f&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fce26f"]])

export default __exports__